export default __webpack_public_path__ + "static/media/airdockz-cbb-3.ba775f15.png";